import { ITableColumn } from '@components/common/UTable/UTable';

import { TransformedDictionaries } from '@/api/dictionaries/types';
import { IndividualSex, IndividualSexLabel } from '@/shared/vaccination/enums';

export const ANY_SEX_LABEL = 'Любой';
export const ALL_SPECIES_LABEL = 'Без привязки (все группы)';

export const transitionColumns = (
  dictMap: TransformedDictionaries | undefined,
): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Из группы',
    dataIndex: 'fromSpeciesId',
    render: (value: string) => dictMap?.ANIMAL_SPECIES?.[value]?.name || '',
  },
  {
    title: 'Пол',
    dataIndex: 'sex',
    render: (value: IndividualSex | null) =>
      value ? IndividualSexLabel[value] : ANY_SEX_LABEL,
  },
  {
    title: 'В группу',
    dataIndex: 'toSpeciesId',
    render: (value: string) => dictMap?.ANIMAL_SPECIES?.[value]?.name || '',
  },
  {
    title: 'Возраст перехода (дней)',
    dataIndex: 'maxAgeDays',
    align: 'center',
  },
];

export const protocolTypeColumns = (
  dictMap: TransformedDictionaries | undefined,
): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Тип схемы',
    dataIndex: 'name',
  },
  {
    title: 'Группа животных',
    dataIndex: 'animalSpeciesId',
    render: (value: string | null) =>
      value ? dictMap?.ANIMAL_SPECIES?.[value]?.name || '' : ALL_SPECIES_LABEL,
  },
];
